module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Macro-Trend","belongs":"Dieser Trend gehört zum Mega-Trend: "},"en":{"title":"Macro-trend","belongs":"This trend belongs to mega-trend: "}}')
  delete Component.options._Ctor
}
